import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';

import { PERMISSIONS, anyOrgPermissions } from '@/app/permissions';
import { AdminPage } from '@/features/admin/admin-page';
import { ADMIN_TABS } from '@/features/admin/tabs';
import { getSession } from '@/lib/auth/session';

const searchSchema = z.object({ tab: z.enum(ADMIN_TABS).optional().catch(undefined) });

export const Route = createFileRoute('/_app/admin')({
  validateSearch: searchSchema,
  beforeLoad: () => {
    // Staff only. Everyone else gets the same "page not found" as a typo would:
    // the console's existence is not advertised (the server refuses anyway).
    if (!anyOrgPermissions(getSession().me).has(PERMISSIONS.admin)) throw notFound();
  },
  component: AdminRoute,
});

function AdminRoute() {
  const { tab = 'verifications' } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AdminPage
      tab={tab}
      onTab={(next) => void navigate({ search: { tab: next }, replace: true })}
    />
  );
}
